import React, { useState } from 'react';
import { ModalStepper } from 'src/components/Proposal/ModalStepper';

import { Button, Card, TextInput, Textarea } from '@sravni/react-design-system';
import { useBoolean, useIsMobile } from '@sravni/react-utils';

import { required, validate } from '../../../utils/validationFrom';
import { Field, Form, FromBlock, FromGroup } from '../Form';

import styles from './styles.module.scss';

export interface IShareArticleForm {
  fio?: string;
  email?: string;
  header?: string;
  purpose?: string;
  comment?: string;
  event_date?: string;
}

interface Props {
  onSubmit?: (fields: IShareArticleForm) => void;
}

const validateConfig = {
  fio: [required],
  email: [required],
  header: [required],
  purpose: [required],
  comment: [required],
};

const stepFields = ['fio', 'email', 'header', 'purpose', 'comment', 'event_date'];

export const ShareArticleForm: React.FC<Props> = ({ onSubmit }) => {
  const isMobile = useIsMobile();
  const [visible, setVisible] = useBoolean(false);
  const [step, setStep] = useState(0);
  return (
    <Card className={styles.card}>
      <Form onSubmit={onSubmit} validateConfig={validateConfig}>
        {({ errors, fields, handleChange, setError }) => {
          const onFocus = (e: React.FormEvent) => {
            //@ts-ignore
            const newStep = stepFields.findIndex((el) => el === e.target.name);

            setStep(newStep);
            isMobile && setVisible.on();
          };

          const handleStepChange = (nextStep: number) => {
            const key = stepFields[step];
            const validateResult = validate(validateConfig[key])(Object.values(fields)[step]);
            if (!validateResult || nextStep < step) {
              setStep(nextStep);
            } else {
              setError(key, validateResult);
            }
          };
          return (
            <>
              <FromBlock title="Ваше имя и контакт для связи">
                <FromGroup>
                  <Field error={errors.fio}>
                    <TextInput
                      name="fio"
                      value={fields.fio}
                      label="Как к вам обращаться"
                      onChange={handleChange}
                      onFocus={onFocus}
                    />
                  </Field>
                  <Field error={errors.email}>
                    <TextInput
                      label="Подойдут telegram, почта"
                      name="email"
                      value={fields.email}
                      onChange={handleChange}
                      onFocus={onFocus}
                    />
                  </Field>
                </FromGroup>
              </FromBlock>

              <FromBlock title="Детали статьи">
                <FromGroup>
                  <Field
                    message="Например: личный опыт: я использую 10 банковских карт и получаю 30 000 ₽ кэшбэка каждый месяц"
                    error={errors.header}
                  >
                    <TextInput
                      label="Заголовок статьи"
                      name="header"
                      value={fields.header}
                      onChange={handleChange}
                      onFocus={onFocus}
                    />
                  </Field>
                  <Field
                    message="Статья поможет читателю экономить на покупках до 30 тысяч ₽ в месяц"
                    error={errors.purpose}
                  >
                    <TextInput
                      name="purpose"
                      label="Цель"
                      value={fields.purpose}
                      onChange={handleChange}
                      onFocus={onFocus}
                    />
                  </Field>
                </FromGroup>

                <Field error={errors.comment} className="h-mt-24">
                  <Textarea
                    name="comment"
                    label="Краткое описание: о чём будет статья"
                    value={fields.comment}
                    onChange={handleChange}
                    onFocus={onFocus}
                    rows={5}
                  />
                </Field>

                <Field error={errors['event_date']} className="h-mt-24">
                  <Textarea
                    name="event_date"
                    placeholder="Если в статье речь идёт о событии, то когда оно случилось?"
                    value={fields['event_date']}
                    onChange={handleChange}
                    onFocus={onFocus}
                    className={styles['text-area']}
                    rows={2}
                  />
                </Field>
              </FromBlock>

              <Button type="submit" className={styles.button} variant="primary">
                Отправить
              </Button>

              <ModalStepper
                step={step}
                onChange={handleStepChange}
                visible={visible}
                onClose={() => {
                  setVisible.off();
                  setStep(0);
                }}
              >
                <>
                  <ModalStepper.Step title="Как к вам обращаться">
                    <Field error={errors.fio}>
                      <TextInput name="fio" value={fields.fio} onChange={handleChange} />
                    </Field>
                  </ModalStepper.Step>

                  <ModalStepper.Step title="Контакт для связи">
                    <Field error={errors.email} message="Моб. телефон, телеграм или эл. почта">
                      <TextInput name="email" value={fields.email} onChange={handleChange} />
                    </Field>
                  </ModalStepper.Step>

                  <ModalStepper.Step title="Заголовок статьи">
                    <Field
                      message="Например: личный опыт: я использую 10 банковских карт и получаю 30 000 ₽ кэшбэка каждый месяц"
                      error={errors.header}
                    >
                      <TextInput name="header" value={fields.header} onChange={handleChange} />
                    </Field>
                  </ModalStepper.Step>
                  <ModalStepper.Step title="Цель">
                    <Field
                      message="Статья поможет читателю экономить на покупках до 30 тысяч ₽ в месяц"
                      error={errors.purpose}
                    >
                      <TextInput name="purpose" label="Цель" value={fields.purpose} onChange={handleChange} />
                    </Field>
                  </ModalStepper.Step>
                  <ModalStepper.Step title="Краткое описание">
                    <Field error={errors.comment}>
                      <TextInput name="comment" value={fields.comment} onChange={handleChange} onFocus={onFocus} />
                    </Field>
                  </ModalStepper.Step>
                  <ModalStepper.Step title="Если в статье речь идёт о событии, то когда оно случилось?">
                    <Field error={errors['event_date']}>
                      <TextInput
                        name="event_date"
                        value={fields['event_date']}
                        onChange={handleChange}
                        onFocus={onFocus}
                      />
                    </Field>
                  </ModalStepper.Step>
                </>
              </ModalStepper>
            </>
          );
        }}
      </Form>
    </Card>
  );
};
